import { useContext, useEffect, useState } from "react"
import { Link, Outlet, useLocation, useParams } from "react-router-dom"
import { CampaignContext, VibratoClientContext } from "./contexts"

export default function CampaignLayout(): any {
  const { uuid } = useParams()
  const [campaign, setCampaign] = useState<any>(null)
  const location = useLocation()
  const vibratoClient = useContext(VibratoClientContext)

  useEffect(() => {
    if (uuid) {
      const fetchCampaign = async () => {
        try {
          const campaignData = await vibratoClient.getCampaign(uuid)
          setCampaign(campaignData)
        } catch (error) {
          console.error("Failed to fetch campaign:", error)
        }
      }

      fetchCampaign()
    }
  }, [uuid])

  // if (!campaign) {
  //   return <Loading />
  // }

  return (
    <div className="pt-8 pl-8 h-full w-full flex flex-col">
      {campaign && (
        <h1 className="text-2xl font-bold mb-2">
          Campaign - {campaign.name} {campaign.paused && "(Paused)"}
        </h1>
      )}
      {!campaign && <h1 className="text-2xl font-bold mb-2">Campaigns</h1>}
      {campaign && (
        <>
          <nav className="pt-4">
            <div className="max-w-(--breakpoint-xl) flex">
              <div className="flex items-center">
                <ul className="flex flex-row font-medium mt-0 space-x-8 rtl:space-x-reverse text-sm">
                  <li className="flex flex-col justify-between">
                    <Link
                      to={`/campaigns/${uuid}`}
                      className="text-base text-gray-900 dark:text-white hover:underline relative pb-4"
                      aria-current={location.pathname === `/campaigns/${uuid}` ? "page" : undefined}
                    >
                      Settings
                    </Link>
                    {location.pathname === `/campaigns/${uuid}` && <hr className="border-t-2 border-purple-500 mt-1" />}
                  </li>
                  <li className="flex flex-col justify-between">
                    <Link
                      to={`/campaigns/${uuid}/contacts`}
                      className="text-base text-gray-900 dark:text-white hover:underline relative pb-4"
                    >
                      Contacts
                    </Link>
                    {location.pathname === `/campaigns/${uuid}/contacts` && (
                      <hr className="border-t-2 border-purple-500 mt-1" />
                    )}
                  </li>
                  <li className="flex flex-col justify-between">
                    <Link
                      to={`/campaigns/${uuid}/calls`}
                      className="text-base text-gray-900 dark:text-white hover:underline relative pb-4"
                    >
                      Calls
                    </Link>
                    {location.pathname === `/campaigns/${uuid}/calls` && (
                      <hr className="border-t-2 border-purple-500 mt-1" />
                    )}
                  </li>
                </ul>
              </div>
            </div>
          </nav>
          <hr className="h-px bg-gray-200 border-0 dark:bg-gray-700" />
        </>
      )}
      <CampaignContext.Provider value={{ campaign, setCampaign } as any}>
        <Outlet />
      </CampaignContext.Provider>
    </div>
  )
}
